import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Spinner from '@atlaskit/spinner';
import { token } from '@atlaskit/tokens';

const Wrapper = styled.div`
    display: flex;
    height: 100vh;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    p {
        display: block;
        text-align: center;
        margin-bottom: 14px;
    }
`;

const Message = styled.p`
    color: ${token('color.text')};
`;

const Loading = (props) => {
    const { message = 'Loading components...' } = props;

    return (
        <Wrapper>
            <Message>{message}</Message>
            <Spinner size="large" />
        </Wrapper>
    );
};

Loading.propTypes = {
    message: PropTypes.string,
};

export default Loading;
